import { PostWrapper, PutWrapper } from "../../../axios";
import { IAutoComplete, ISale } from "../../../models";

export const postMakeSale = (data: ISale) => PostWrapper<null>("/Sales/MakeSale", data);

export const postResendReceipt = (data: { saleID: number }) => PostWrapper<null>("/Sales/ResendReceipt", data);

export const putUpdateContacts = (data: Array<IAutoComplete>) => PutWrapper<null>("/Sales/UpdateContacts", data);
